<template>
  <div class="tinto-page">
    <Loading :isActive="loading" />

    <!-- ===== MODAL: FORM (criar / editar) ===== -->
    <modal name="integracaoForm" height="auto" width="700" :adaptive="true" :scrollable="true" :clickToClose="false">
      <CloseModal :close="closeForm" />
      <div class="modalbox">
        <div class="modalbox-content">
          <h5 class="tinto-modal__title">{{ form.id ? 'Editar Integração' : 'Nova Integração' }}</h5>

          <div class="tinto-section">
            <div class="tinto-section__label"><fa-icon icon="tag" class="mr-1" />Identificação</div>
            <CRow>
              <CCol md="7">
                <div class="form-group"><label class="tinto-label">Descrição</label>
                  <input class="form-control form-control-sm" v-model="form.descricao" placeholder="Nome da integração" />
                </div>
              </CCol>
              <CCol md="5">
                <div class="form-group"><label class="tinto-label">Fabricante</label>
                  <select class="form-control form-control-sm" v-model="selFabricanteChave">
                    <option value="">Selecione</option>
                    <option v-for="f in chavesFabricante" :key="f.chave" :value="f.chave">{{ f.label }}</option>
                  </select>
                </div>
              </CCol>
            </CRow>
            <CRow v-if="selFabricanteChave">
              <CCol md="6">
                <div class="form-group">
                  <label class="tinto-label">
                    Tipo de Integração
                    <fa-icon
                      v-if="permiteAlternarTipo"
                      icon="info-circle"
                      class="tinto-label__info"
                      title="Este fabricante suporta conexão por API e por Banco de Dados. Use o botão para alternar entre as opções."
                    />
                  </label>
                  <!-- Mesmo botão segmentado para 1 ou 2 tipos: com um único tipo,
                       renderiza um botão único já ativo (visual idêntico ao Coral). -->
                  <div class="tinto-toggle">
                    <button
                      v-for="t in tiposDaChaveSelecionada"
                      :key="t.tipo"
                      type="button"
                      :class="['tinto-toggle__btn', { 'is-active': selTipoIntegracao === t.tipo }]"
                      @click="selTipoIntegracao = t.tipo"
                    >
                      <fa-icon :icon="t.tipo === 'api_rest' ? 'cloud' : 'database'" class="mr-1" />
                      {{ t.label }}
                    </button>
                  </div>
                  <small v-if="observacaoTipoSelecionado" class="tinto-hint">
                    <fa-icon icon="info-circle" class="mr-1" />{{ observacaoTipoSelecionado }}
                  </small>
                </div>
              </CCol>
            </CRow>
          </div>

          <div class="tinto-section">
            <div class="tinto-section__label">
              <fa-icon icon="building" class="mr-1" />Filiais atendidas
              <fa-icon
                icon="info-circle"
                class="tinto-label__info"
                title="Uma integração pode atender várias filiais. Marque todas as filiais que usam esta integração — mesmas credenciais, fabricante e configurações."
              />
            </div>

            <div class="tinto-picker">
              <div class="tinto-picker__bar">
                <div class="tinto-picker__search">
                  <fa-icon icon="search" class="tinto-picker__search-icon" />
                  <input
                    type="text"
                    class="tinto-picker__search-input"
                    v-model="filialBusca"
                    placeholder="Buscar por código ou nome..."
                  />
                  <fa-icon
                    v-if="filialBusca"
                    icon="times"
                    class="tinto-picker__search-clear"
                    @click="filialBusca = ''"
                  />
                </div>
                <div class="tinto-picker__actions">
                  <span class="tinto-picker__count">{{ form.filiais.length }}/{{ totalFiliais }}</span>
                  <button type="button" class="tinto-picker__link" @click="selecionarTodasFiliais">
                    <fa-icon icon="check-square" class="mr-1" />Todas
                  </button>
                  <button
                    type="button"
                    class="tinto-picker__link"
                    :disabled="!form.filiais.length"
                    @click="limparFiliais"
                  >
                    <fa-icon icon="times" class="mr-1" />Limpar
                  </button>
                </div>
              </div>

              <div class="tinto-picker__list">
                <label
                  v-for="f in filiaisFiltradas"
                  :key="f.id"
                  class="tinto-picker__item"
                  :class="{ 'is-active': form.filiais.includes(f.id) }"
                >
                  <input type="checkbox" :value="f.id" v-model="form.filiais" />
                  <span class="tinto-picker__item-id">{{ f.id }}</span>
                  <span class="tinto-picker__item-nome">{{ f.nome }}</span>
                </label>
                <div v-if="!filiaisFiltradas.length" class="tinto-picker__empty">
                  Nenhuma filial encontrada
                </div>
              </div>
            </div>

            <small v-if="!form.filiais.length" class="tinto-hint tinto-hint--warn">
              <fa-icon icon="exclamation-triangle" class="mr-1" />Selecione ao menos uma filial.
            </small>
          </div>

          <div v-if="tipoIntegracao === 'database'" class="tinto-section">
            <div class="tinto-section__label"><fa-icon icon="database" class="mr-1" />Conexão Banco de Dados</div>
            <CRow>
              <CCol md="4"><div class="form-group"><label class="tinto-label">Host</label>
                <input class="form-control form-control-sm" v-model="form.database_ip" placeholder="10.1.1.96" /></div></CCol>
              <CCol md="2"><div class="form-group"><label class="tinto-label">Porta</label>
                <input class="form-control form-control-sm" v-model="form.database_port" placeholder="5432" /></div></CCol>
              <CCol md="6"><div class="form-group"><label class="tinto-label">Charset</label>
                <input class="form-control form-control-sm" v-model="form.database_charset" placeholder="ISO-8859-1" /></div></CCol>
            </CRow>
            <CRow>
              <CCol md="4"><div class="form-group"><label class="tinto-label">Banco</label>
                <input class="form-control form-control-sm" v-model="form.database_name" /></div></CCol>
              <CCol md="4"><div class="form-group"><label class="tinto-label">Usuário</label>
                <input
                  class="form-control form-control-sm"
                  v-model="form.database_user"
                  autocomplete="off"
                /></div></CCol>
              <CCol md="4"><div class="form-group"><label class="tinto-label">Senha</label>
                <input
                  class="form-control form-control-sm"
                  type="password"
                  v-model="form.database_password"
                  autocomplete="new-password"
                  :placeholder="form.id ? 'Deixe em branco para manter a senha atual' : ''"
                /></div></CCol>
            </CRow>
          </div>

          <div v-if="tipoIntegracao === 'api_rest'" class="tinto-section">
            <div class="tinto-section__label"><fa-icon icon="cloud" class="mr-1" />Conexão API REST</div>
            <div class="form-group">
              <label class="tinto-label">
                URL da API
                <fa-icon
                  icon="info-circle"
                  class="tinto-label__info"
                  title="Não inclua /api no final — os paths são concatenados automaticamente pelo backend."
                />
              </label>
              <input class="form-control form-control-sm" v-model="form.api_url" placeholder="https://integracao.novoselfcolor.suvinil.com.br" />
              <small v-if="apiUrlComApi" class="tinto-hint tinto-hint--warn">
                <fa-icon icon="exclamation-triangle" class="mr-1" />
                A URL termina com <code>/api</code>. Será removido automaticamente ao salvar.
              </small>
            </div>
            <CRow>
              <CCol md="6"><div class="form-group"><label class="tinto-label">Access Key</label>
                <input
                  class="form-control form-control-sm"
                  type="text"
                  v-model="form.api_access_key"
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false"
                  :placeholder="form.id ? 'Deixe em branco para manter a chave atual' : ''"
                /></div></CCol>
              <CCol md="6"><div class="form-group"><label class="tinto-label">Access Secret</label>
                <input
                  class="form-control form-control-sm"
                  type="password"
                  v-model="form.api_access_secret"
                  autocomplete="new-password"
                  :placeholder="form.id ? 'Deixe em branco para manter o secret atual' : ''"
                /></div></CCol>
            </CRow>
            <CRow v-if="exigeDadosEmpresa">
              <CCol md="4"><div class="form-group">
                <label class="tinto-label">
                  Sigla da Tinta <span class="text-danger">*</span>
                  <fa-icon
                    icon="info-circle"
                    class="tinto-label__info"
                    title="Sigla da linha de tinta fornecida pela Citel (ex.: CIM). Usada no caminho das chamadas à API."
                  />
                </label>
                <input class="form-control form-control-sm" v-model="form.database_charset" placeholder="CIM" /></div></CCol>
              <CCol md="4"><div class="form-group">
                <label class="tinto-label">
                  Código da Empresa <span class="text-danger">*</span>
                  <fa-icon
                    icon="info-circle"
                    class="tinto-label__info"
                    title="Código da empresa na Citel (ex.: 001). Enviado como codigoEmpresa na precificação."
                  />
                </label>
                <input class="form-control form-control-sm" v-model="form.database_name" placeholder="001" /></div></CCol>
              <CCol md="4"><div class="form-group">
                <label class="tinto-label">
                  Cliente de Referência <span class="text-danger">*</span>
                  <fa-icon
                    icon="info-circle"
                    class="tinto-label__info"
                    title="Cliente usado na sincronização para resolver o código do produto via API. Fornecido pela Citel (ex.: 00000001)."
                  />
                </label>
                <input class="form-control form-control-sm" v-model="form.codigo_cliente_referencia" placeholder="00000001" /></div></CCol>
            </CRow>
          </div>

          <div class="tinto-section">
            <div class="tinto-section__label"><fa-icon icon="cogs" class="mr-1" />Configurações Gerais</div>
            <CRow>
              <CCol md="4">
                <div class="form-group">
                  <label class="tinto-label">
                    Usar filtro de linha
                    <fa-icon
                      icon="info-circle"
                      class="tinto-label__info"
                      title="Exibe uma etapa para o usuário escolher a linha antes de listar as cores."
                    />
                  </label>
                  <select class="form-control form-control-sm" v-model="form.usa_filtro_linha">
                    <option :value="false">Não</option>
                    <option :value="true">Sim</option>
                  </select>
                </div>
              </CCol>
              <CCol md="4">
                <div class="form-group">
                  <label class="tinto-label">
                    Linha obrigatória
                    <fa-icon
                      icon="info-circle"
                      class="tinto-label__info"
                      title="Quando ativo, a escolha da linha não pode ser pulada. Só se aplica com o filtro de linha ativo."
                    />
                  </label>
                  <select
                    class="form-control form-control-sm"
                    v-model="form.filtro_linha_obrigatorio"
                    :disabled="!form.usa_filtro_linha"
                  >
                    <option :value="false">Não</option>
                    <option :value="true">Sim</option>
                  </select>
                </div>
              </CCol>
              <CCol md="4">
                <div class="form-group">
                  <label class="tinto-label">
                    Usar filtro de coleção
                    <fa-icon
                      icon="info-circle"
                      class="tinto-label__info"
                      title="Exibe uma etapa para o usuário escolher a coleção (submarca) antes de listar as cores."
                    />
                  </label>
                  <select class="form-control form-control-sm" v-model="form.usa_filtro_colecao">
                    <option :value="false">Não</option>
                    <option :value="true">Sim</option>
                  </select>
                </div>
              </CCol>
              <CCol md="4">
                <div class="form-group">
                  <label class="tinto-label">
                    Usa restrição de segmento de venda
                    <fa-icon
                      icon="info-circle"
                      class="tinto-label__info"
                      title="Quando ativo, aplica a restrição de segmento de venda na composição de preço do tintométrico."
                    />
                  </label>
                  <select class="form-control form-control-sm" v-model="form.usa_restricao_segmento_venda">
                    <option :value="false">Não</option>
                    <option :value="true">Sim</option>
                  </select>
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="4">
                <div class="form-group">
                  <label class="tinto-label">
                    Sincronização automática
                    <fa-icon
                      icon="info-circle"
                      class="tinto-label__info"
                      title="Quando a sincronização desta integração roda sozinha, em formato cron. Em branco, ela só acontece pelo botão Sincronizar."
                    />
                  </label>
                  <select class="form-control form-control-sm" v-model="presetCron" @change="aplicarPresetCron()">
                    <option v-for="preset in presetsCron" :key="preset.valor" :value="preset.valor">{{ preset.rotulo }}</option>
                  </select>
                </div>
              </CCol>
              <CCol md="4" v-if="presetCron === 'personalizado'">
                <div class="form-group">
                  <label class="tinto-label">
                    Expressão cron
                    <fa-icon
                      icon="info-circle"
                      class="tinto-label__info"
                      title="Cinco campos: minuto hora dia-do-mês mês dia-da-semana. Ex.: 0 3 * * * (todo dia às 3h) ou 30 23 */2 * * (de dois em dois dias às 23:30)."
                    />
                  </label>
                  <input class="form-control form-control-sm" v-model="form.sync_cron" placeholder="0 3 * * *" />
                  <small class="tinto-campo__ajuda">{{ descricaoCron }}</small>
                </div>
              </CCol>
              <CCol md="4" v-if="tipoIntegracao === 'database'">
                <div class="form-group">
                  <label class="tinto-label">
                    Inserir pedido no banco do tintômetro
                    <fa-icon
                      icon="info-circle"
                      class="tinto-label__info"
                      title="Quando ativo, ao liberar um pedido tintométrico ele é inserido automaticamente no banco do tintômetro (ShotColor/Coral). Aplica-se apenas a integrações por banco de dados."
                    />
                  </label>
                  <select class="form-control form-control-sm" v-model="form.envia_pedido_integracao">
                    <option :value="false">Não</option>
                    <option :value="true">Sim</option>
                  </select>
                </div>
              </CCol>
              <CCol md="4" v-if="tipoIntegracao === 'database'">
                <div class="form-group">
                  <label class="tinto-label">
                    Remover pedido cancelado do tintômetro
                    <fa-icon
                      icon="info-circle"
                      class="tinto-label__info"
                      title="Quando ativo, cancelar um pedido apaga do banco do tintômetro a venda que havia sido gravada — desde que a máquina ainda não a tenha assumido (venda já em produção, fechada ou com lata dosada nunca é apagada). Aplica-se apenas a integrações por banco de dados."
                    />
                  </label>
                  <select class="form-control form-control-sm" v-model="form.cancela_pedido_integracao">
                    <option :value="false">Não</option>
                    <option :value="true">Sim</option>
                  </select>
                </div>
              </CCol>
            </CRow>
            <div class="form-group">
              <label class="tinto-label">
                E-mail para Pedido Liberado
                <fa-icon
                  icon="info-circle"
                  class="tinto-label__info"
                  title="Múltiplos e-mails separados por vírgula. Se vazio, será usado o parâmetro global GERAL_EMAIL_PEDIDO_LIBERADO_TINTOMETRICO."
                />
              </label>
              <textarea
                class="form-control form-control-sm"
                v-model="form.email_pedido_liberado"
                rows="2"
                maxlength="2000"
                placeholder="exemplo1@dominio.com, exemplo2@dominio.com"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="tinto-modal__footer">
        <button class="button" @click="closeForm">Cancelar</button>
        <button class="button button-primary" @click="submitForm">Salvar</button>
      </div>
    </modal>

    <!-- ===== MODAL: SINCRONIZAÇÃO (histórico + testar + sincronizar) ===== -->
    <modal name="integracaoSync" height="auto" width="860" :scrollable="true" :clickToClose="true">
      <CloseModal :close="closeSync" />
      <div class="modalbox">
        <div class="modalbox-content">
          <h5 class="tinto-modal__title">
            <fa-icon icon="sync" class="mr-2" style="color:#667085" />
            Sincronização — {{ currentIntegracao.descricao }}
          </h5>

          <div class="d-flex align-items-center mb-3" style="gap:8px">
            <button class="button button-info" @click="testConnModal" :disabled="testando">
              <fa-icon :icon="testando ? 'spinner' : 'plug'" :spin="testando" class="mr-1" />
              Testar Conexão
            </button>
            <button class="button button-primary" @click="runSync" :disabled="sincronizando || syncEmAndamento">
              <fa-icon :icon="sincronizando ? 'spinner' : 'bolt'" :spin="sincronizando" class="mr-1" />
              Sincronizar Agora
            </button>
          </div>

          <!-- Progresso em tempo real -->
          <div v-if="syncEmAndamento" class="tinto-section" style="margin-bottom:14px">
            <div class="tinto-section__label"><fa-icon icon="spinner" spin class="mr-1" />Sincronização em andamento...</div>
            <div class="tinto-sync-steps">
              <div v-for="step in syncStepNames" :key="step" class="tinto-sync-step">
                <span class="tinto-sync-step__icon">
                  <fa-icon v-if="stepStatus(step) === 'done'" icon="check-circle" style="color:#027a48" />
                  <fa-icon v-else-if="stepStatus(step) === 'error'" icon="exclamation-triangle" style="color:#b42318" />
                  <fa-icon v-else-if="stepStatus(step) === 'running'" icon="spinner" spin style="color:#004576" />
                  <fa-icon v-else icon="circle" style="color:#d0d5dd;font-size:8px" />
                </span>
                <span class="tinto-sync-step__name">{{ step }}</span>
                <template v-if="stepStatus(step) === 'done'">
                  <span class="tinto-sync-step__detail">{{ stepDetail(step) }}</span>
                </template>
                <template v-else-if="stepStatus(step) === 'running' && stepProgress(step)">
                  <span class="tinto-sync-step__progress">
                    <span class="tinto-progress-bar">
                      <span class="tinto-progress-bar__fill" :style="{ width: stepProgress(step).pct + '%' }"></span>
                    </span>
                    <span class="tinto-sync-step__counter">{{ stepProgress(step).processados | number }} / {{ stepProgress(step).total | number }} ({{ stepProgress(step).pct }}%)</span>
                  </span>
                </template>
              </div>
            </div>
          </div>

          <!-- Histórico -->
          <div class="tinto-section">
            <div class="tinto-section__label">Histórico de Sincronizações</div>
            <div v-if="loadingHistorico" class="tinto-table__empty">
              <fa-icon icon="spinner" spin /> Carregando...
            </div>
            <div v-else class="tinto-table-wrap">
              <table class="tinto-table">
                <thead><tr>
                  <th style="width:160px">Início</th>
                  <th style="width:90px;text-align:center">Status</th>
                  <th style="width:90px;text-align:right">Duração</th>
                  <th style="width:90px;text-align:center">Disparado</th>
                  <th>Mensagem</th>
                </tr></thead>
                <tbody>
                  <tr v-if="historico.length === 0">
                    <td colspan="5" class="tinto-table__empty">Nenhuma sincronização registrada</td>
                  </tr>
                  <tr v-for="h in historico" :key="h.id">
                    <td><span class="tinto-table__sub">{{ h.iniciado_em | dt }}</span></td>
                    <td style="text-align:center">
                      <span :class="['tinto-badge', syncStatusClass(h.status)]">{{ h.status }}</span>
                    </td>
                    <td style="text-align:right">
                      <span v-if="h.tempo_execucao_ms" class="tinto-table__sub">{{ formatMs(h.tempo_execucao_ms) }}</span>
                      <span v-else class="tinto-table__muted">—</span>
                    </td>
                    <td style="text-align:center">
                      <span class="tinto-table__sub">{{ h.disparado_por || '—' }}</span>
                    </td>
                    <td><span class="tinto-table__sub">{{ h.mensagem || '—' }}</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="tinto-modal__footer">
        <button class="button" @click="closeSync">Fechar</button>
      </div>
    </modal>

    <!-- ===== HEADER ===== -->
    <div class="tinto-page__header" style="justify-content: flex-end">
      <button class="button button-primary" @click="openCreate">
        <fa-icon icon="plus" /> Nova
      </button>
    </div>

    <!-- ===== TABLE ===== -->
    <div class="tinto-table-wrap">
      <table class="tinto-table">
        <thead><tr>
          <th style="width:50px">ID</th>
          <th style="width:240px">Descrição</th>
          <th style="width:110px">Fabricante</th>
          <th style="width:200px">Filiais</th>
          <th style="width:150px;text-align:center">Última Sync</th>
          <th style="width:60px;text-align:center">Ativo</th>
          <th style="width:140px"></th>
        </tr></thead>
        <tbody>
          <tr v-if="items.length === 0"><td colspan="7" class="tinto-table__empty">Nenhuma integração cadastrada</td></tr>
          <tr v-for="r in items" :key="r.id">
            <td>{{ r.id }}</td>
            <td>
              <span class="tinto-table__primary">{{ r.descricao }}</span>
              <span class="tinto-table__sub" v-if="r.databaseIp">{{ r.databaseIp }}:{{ r.databasePort }}</span>
              <span class="tinto-table__sub" v-else-if="r.apiUrl">{{ r.apiUrl }}</span>
            </td>
            <td>{{ r.fabricanteNome }}</td>
            <td>
              <div v-if="(r.filiais || []).length" class="tinto-chips" :title="filiaisNomes(r)">
                <span
                  v-for="id in (r.filiais || []).slice(0, 3)"
                  :key="id"
                  class="tinto-chip"
                >{{ filialLabel(id) }}</span>
                <span
                  v-if="(r.filiais || []).length > 3"
                  class="tinto-chip tinto-chip--more"
                >+{{ r.filiais.length - 3 }}</span>
              </div>
              <span v-else class="tinto-table__muted">—</span>
            </td>
            <td style="text-align:center">
              <template v-if="r.ultimaSyncEm">
                <span class="tinto-table__primary" style="font-size:12px;font-weight:400">{{ r.ultimaSyncEm | dtDate }}</span>
                <span class="tinto-table__sub">{{ r.ultimaSyncEm | dtTime }}</span>
              </template>
              <span v-else class="tinto-table__muted">Nunca</span>
              <!-- Agendamento do cadastro (cron). Sem expressão, a sincronização
                   só acontece pelo botão. -->
              <span v-if="r.syncCron" class="tinto-table__sub">{{ descreverCron(r.syncCron) }}</span>
            </td>
            <td style="text-align:center">
              <span :class="['tinto-dot', r.ativo ? 'tinto-dot--on' : 'tinto-dot--off']"></span>
            </td>
            <td>
              <div class="tinto-actions">
                <button class="button button-primary" @click="edit(r)" title="Editar">
                  <fa-icon icon="pencil-alt" />
                </button>
                <button :class="['button', syncBtnClass(r)]" @click="openSync(r)" title="Sincronização">
                  <fa-icon icon="sync" />
                </button>
                <button class="button button-error" @click="remove(r)" title="Excluir">
                  <fa-icon icon="trash-alt" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import CloseModal from "../../components/CloseModal";
import { get, post, put, del } from '@/helpers/apiRequest';
import _find from 'lodash/find';

const SYNC_STEP_NAMES = ['linhas', 'cores', 'corantes', 'bases', 'formulas', 'embalagens'];
const POLL_INTERVAL_MS = 3000;
const SYNC_START_DELAY_MS = 1500;

const STATUS_MAP = {
  sucesso: 'tinto-badge--success',
  erro:    'tinto-badge--error',
  parcial: 'tinto-badge--warn',
};

function formatDateTime(value) {
  if (!value) return '';
  const d = new Date(value);
  return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

function formatNumber(value) {
  return value ? Number(value).toLocaleString('pt-BR') : '0';
}

export default {
  name: "tintometrico-integracao",
  components: { Loading, CloseModal },
  props: ['filiais', 'fabricantes', 'fabricantesDetalhes'],

  filters: {
    dtDate(v) { return v ? new Date(v).toLocaleDateString('pt-BR') : ''; },
    dtTime(v) { return v ? new Date(v).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : ''; },
    dt: formatDateTime,
    number: formatNumber,
  },

  data() {
    return {
      // Presets cobrem o que o cliente pede no dia a dia; "personalizado" abre
      // a expressão crua para quem precisa de algo fora da lista.
      presetCron: '',
      presetsCron: [
        { valor: '', rotulo: 'Somente pelo botão (sem automática)' },
        { valor: '0 3 * * *', rotulo: 'Todo dia às 03:00' },
        { valor: '0 23 * * *', rotulo: 'Todo dia às 23:00' },
        { valor: '0 3 */2 * *', rotulo: 'De dois em dois dias às 03:00' },
        { valor: '0 3 * * 0', rotulo: 'Aos domingos às 03:00' },
        { valor: '0 */6 * * *', rotulo: 'A cada 6 horas' },
        { valor: 'personalizado', rotulo: 'Personalizado (cron)' },
      ],
      items: [],
      loading: false,
      form: this.emptyForm(),
      filialBusca: '',

      // Seleção de fabricante desacoplada do fabricante_id: o usuário escolhe a
      // chave (ex.: Coral) e o tipo de integração (API/Banco); o id é resolvido
      // a partir desses dois em sincronizarFabricanteId().
      selFabricanteChave: '',
      selTipoIntegracao: '',

      currentIntegracao: {},
      historico: [],
      loadingHistorico: false,
      testando: false,
      sincronizando: false,
      pollTimer: null,
      syncStepNames: SYNC_STEP_NAMES,
    };
  },

  computed: {
    // Lê de volta, em português, a expressão que o usuário digitou.
    descricaoCron() {
      return this.form.sync_cron ? this.descreverCron(this.form.sync_cron) : 'Em branco: só pelo botão Sincronizar.';
    },

    // Chaves de fabricante distintas entre os cadastrados (ex.: "Coral", "Suvinil").
    chavesFabricante() {
      const map = {};
      (this.fabricantesDetalhes || []).forEach(f => {
        if (!map[f.chave]) {
          map[f.chave] = { chave: f.chave, label: f.chave };
        }
      });
      return Object.values(map);
    },

    // Tipos de integração cadastrados para a chave selecionada (cada um aponta
    // para o fabricante_id correspondente — é assim que resolvemos o id ao salvar).
    tiposDaChaveSelecionada() {
      if (!this.selFabricanteChave) return [];
      return (this.fabricantesDetalhes || [])
        .filter(f => f.chave === this.selFabricanteChave)
        .map(f => ({
          tipo: f.tipoIntegracao,
          id: f.id,
          // Rótulo curto vem do backend (ex.: "API Citel"); fallback genérico.
          label: f.rotuloTipo || this.tipoIntegracaoLabel(f.tipoIntegracao),
          observacao: f.observacaoTipo || '',
        }));
    },

    // Só faz sentido alternar quando o fabricante está cadastrado nos dois tipos.
    permiteAlternarTipo() {
      return this.tiposDaChaveSelecionada.length > 1;
    },

    // Observação (ex.: limitação do gateway Citel) do tipo atualmente selecionado.
    observacaoTipoSelecionado() {
      const tipo = this.tiposDaChaveSelecionada.find(t => t.tipo === this.selTipoIntegracao);
      return tipo ? tipo.observacao : '';
    },

    // Tipo efetivo da integração — controla qual bloco (DB ou API REST) é exibido.
    tipoIntegracao() {
      return this.selTipoIntegracao;
    },

    // O gateway do fabricante selecionado usa os campos de empresa (sigla da
    // tinta, código da empresa, cliente de referência)? A flag vem do backend
    // (config do fabricante — hoje só Coral/Citel); Suvinil não usa nenhum dos
    // três. API antiga sem a flag na resposta = exige para todo api_rest, para
    // não afrouxar a Citel se o painel subir antes da API.
    exigeDadosEmpresa() {
      if (this.tipoIntegracao !== 'api_rest') return false;
      const fabricante = _find(this.fabricantesDetalhes, { id: Number(this.form.fabricante_id) });
      if (!fabricante || fabricante.exigeDadosEmpresa === undefined) return true;
      return !!fabricante.exigeDadosEmpresa;
    },

    syncEmAndamento() {
      return this.historico.some(h => h.status === 'executando');
    },

    execucaoAtiva() {
      return this.historico.find(h => h.status === 'executando') || null;
    },

    apiUrlComApi() {
      const url = (this.form.api_url || '').trim();
      return /\/api\/?$/i.test(url);
    },

    // Lista normalizada de filiais (a prop `filiais` é um map { id: nome }).
    filiaisLista() {
      return Object.entries(this.filiais || {})
        .map(([id, nome]) => ({ id: String(id), nome }))
        .sort((a, b) => a.id.localeCompare(b.id, undefined, { numeric: true }));
    },

    totalFiliais() {
      return this.filiaisLista.length;
    },

    filiaisFiltradas() {
      const termo = (this.filialBusca || '').trim().toLowerCase();
      if (!termo) return this.filiaisLista;
      return this.filiaisLista.filter(
        f => `${f.id} ${f.nome}`.toLowerCase().includes(termo)
      );
    },
  },

  watch: {
    selFabricanteChave() {
      // Ao trocar de fabricante, mantém o tipo atual se ele existir para a nova
      // chave; senão cai no primeiro tipo disponível.
      const tipos = this.tiposDaChaveSelecionada;
      if (!tipos.some(t => t.tipo === this.selTipoIntegracao)) {
        this.selTipoIntegracao = tipos.length ? tipos[0].tipo : '';
      }
      this.sincronizarFabricanteId();
    },
    selTipoIntegracao() {
      this.sincronizarFabricanteId();
    },
  },

  beforeMount() { this.load(); },
  beforeDestroy() { this.stopPolling(); },

  methods: {
    // ── CRUD ──────────────────────────────────────────

    emptyForm() {
      return {
        id: null,
        descricao: '',
        filiais: [],
        fabricante_id: '',
        database_ip: '',
        database_port: '',
        database_name: '',
        database_charset: '',
        database_user: '',
        database_password: '',
        codigo_cliente_referencia: '',
        api_url: '',
        api_access_key: '',
        api_access_secret: '',
        email_pedido_liberado: '',
        usa_filtro_linha: false,
        filtro_linha_obrigatorio: false,
        usa_filtro_colecao: false,
        usa_restricao_segmento_venda: false,
        sync_cron: '',
        envia_pedido_integracao: false,
        cancela_pedido_integracao: false,
      };
    },

    // Mapeia o tipo_integracao técnico para o rótulo exibido.
    tipoIntegracaoLabel(tipo) {
      return tipo === 'api_rest' ? 'API REST' : 'Banco de Dados';
    },

    // Resolve o fabricante_id a partir da chave + tipo selecionados.
    sincronizarFabricanteId() {
      const match = this.tiposDaChaveSelecionada.find(t => t.tipo === this.selTipoIntegracao);
      this.form.fabricante_id = match ? match.id : '';
    },

    load() {
      this.loading = true;
      get('/admin/tintometrico/integracao')
        .then(json => { this.items = json.data || json; })
        .finally(() => { this.loading = false; });
    },

    openCreate() {
      this.form = this.emptyForm();
      this.filialBusca = '';
      this.selFabricanteChave = '';
      this.selTipoIntegracao = '';
      this.$modal.show('integracaoForm');
    },

    // ── FILIAIS ───────────────────────────────────────

    // "Todas" respeita a busca: adiciona as filiais atualmente filtradas à
    // seleção (união), sem remover as já marcadas que ficaram fora do filtro.
    selecionarTodasFiliais() {
      const ids = new Set(this.form.filiais);
      this.filiaisFiltradas.forEach(f => ids.add(f.id));
      this.form.filiais = Array.from(ids);
    },

    limparFiliais() {
      this.form.filiais = [];
    },

    edit(integracao) {
      this.form = {
        id: integracao.id,
        descricao: integracao.descricao,
        filiais: (integracao.filiais || []).map(String),
        fabricante_id: integracao.fabricanteId,
        database_ip: integracao.databaseIp,
        database_port: integracao.databasePort,
        database_name: integracao.databaseName,
        database_charset: integracao.databaseCharset,
        database_user: integracao.databaseUser,
        database_password: '',
        codigo_cliente_referencia: integracao.codigoClienteReferencia || '',
        api_url: integracao.apiUrl,
        api_access_key: '',
        api_access_secret: '',
        email_pedido_liberado: integracao.emailPedidoLiberado || '',
        usa_filtro_linha: !!integracao.usaFiltroLinha,
        filtro_linha_obrigatorio: !!integracao.filtroLinhaObrigatorio,
        usa_filtro_colecao: !!integracao.usaFiltroColecao,
        usa_restricao_segmento_venda: !!integracao.usaRestricaoSegmentoVenda,
        sync_cron: integracao.syncCron || '',
        envia_pedido_integracao: !!integracao.enviaPedidoIntegracao,
        cancela_pedido_integracao: !!integracao.cancelaPedidoIntegracao,
      };
      this.presetCron = this.presetDoCron(integracao.syncCron);
      this.filialBusca = '';

      // Reconstrói a seleção (chave + tipo) a partir do fabricante da integração.
      const fabricante = _find(this.fabricantesDetalhes, { id: Number(integracao.fabricanteId) });
      this.selFabricanteChave = fabricante ? fabricante.chave : '';
      this.selTipoIntegracao = fabricante ? fabricante.tipoIntegracao : (integracao.tipoIntegracao || '');

      this.$modal.show('integracaoForm');
    },

    closeForm() {
      this.$modal.hide('integracaoForm');
    },

    submitForm() {
      if (!this.form.fabricante_id) {
        this.$swal({ title: 'Atenção', text: 'Selecione o fabricante e o tipo de integração.', icon: 'warning' });
        return;
      }

      if (this.form.api_url) {
        this.form.api_url = this.form.api_url.trim().replace(/\/api\/?$/i, '');
      }

      // Guarda client-side para gateways que usam os dados de empresa (Citel):
      // os 3 campos reaproveitados são obrigatórios, senão a sincronização
      // falha tardiamente na validação da sigla. Suvinil não usa nenhum deles.
      if (this.exigeDadosEmpresa) {
        const faltando = [];
        if (!this.form.database_charset) faltando.push('Sigla da tinta');
        if (!this.form.database_name) faltando.push('Código da empresa');
        if (!this.form.codigo_cliente_referencia) faltando.push('Cliente de referência');
        if (faltando.length) {
          this.$swal({ title: 'Campos obrigatórios', text: `Preencha: ${faltando.join(', ')}.`, icon: 'warning' });
          return;
        }
      }

      const payload = { ...this.form };

      // Fabricante não exige os dados de empresa (ex: Suvinil): o bloco fica
      // oculto no formulário, mas o payload é spread do form inteiro. Sem
      // isto, valores digitados antes de trocar de fabricante (ou preenchidos
      // só para vencer a validação acima) continuam sendo persistidos num
      // campo que o usuário não vê mais e não tem como corrigir.
      if (!this.exigeDadosEmpresa) {
        payload.database_charset = '';
        payload.database_name = '';
        payload.codigo_cliente_referencia = '';
      }

      // Ids de filial são varchar no backend (podem ser alfanuméricos); envia como string.
      payload.filiais = (this.form.filiais || []).map(String);

      // Coerência: "Linha obrigatória" só faz sentido quando o filtro de linha está ativo.
      if (!payload.usa_filtro_linha) {
        payload.filtro_linha_obrigatorio = false;
      }

      // Horário em branco significa "sem sincronização automática": manda nulo em
      // vez de string vazia para não bater na validação de formato de hora.
      payload.sync_cron = payload.sync_cron || null;

      // Em edição, não envia credenciais vazias para não sobrescrever as já salvas.
      if (payload.id) {
        ['database_password', 'api_access_key', 'api_access_secret'].forEach(key => {
          if (!payload[key]) delete payload[key];
        });
      }

      this.loading = true;
      const request = payload.id
        ? put(`/admin/tintometrico/integracao/${payload.id}`, payload)
        : post('/admin/tintometrico/integracao', payload);

      request
        .then(() => { this.closeForm(); this.load(); })
        .catch(e => { this.$swal({ title: 'Erro', text: e.message, icon: 'error' }); })
        .finally(() => { this.loading = false; });
    },

    // Preset -> expressão. "Personalizado" preserva o que já estava para o
    // usuário editar em vez de zerar o agendamento.
    aplicarPresetCron() {
      if (this.presetCron === 'personalizado') return;
      this.form.sync_cron = this.presetCron;
    },

    presetDoCron(cron) {
      if (!cron) return '';
      const conhecido = this.presetsCron.find((preset) => preset.valor === cron);
      return conhecido ? conhecido.valor : 'personalizado';
    },

    // Texto amigável para a listagem e para a ajuda do campo. Cobre os formatos
    // que os presets geram; o resto aparece como a própria expressão.
    descreverCron(cron) {
      if (!cron) return '';

      const conhecido = this.presetsCron.find((preset) => preset.valor === cron && preset.valor !== 'personalizado');
      if (conhecido) return `automática: ${conhecido.rotulo.toLowerCase()}`;

      const partes = String(cron).trim().split(/\s+/);
      if (partes.length === 5 && /^\d+$/.test(partes[0]) && /^\d+$/.test(partes[1]) && partes.slice(2).join(' ') === '* * *') {
        const hora = String(partes[1]).padStart(2, '0');
        const minuto = String(partes[0]).padStart(2, '0');
        return `automática: todo dia às ${hora}:${minuto}`;
      }

      return `automática: ${cron}`;
    },

    remove(integracao) {
      this.$swal({
        title: 'Excluir integração?',
        text: `"${integracao.descricao}" será removida permanentemente.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
      }).then(result => {
        if (!result.isConfirmed) return;
        this.loading = true;
        del(`/admin/tintometrico/integracao/${integracao.id}`)
          .then(() => { this.load(); })
          .catch(e => { this.$swal({ title: 'Erro', text: e.message, icon: 'error' }); })
          .finally(() => { this.loading = false; });
      });
    },

    // ── SINCRONIZAÇÃO ────────────────────────────────

    openSync(integracao) {
      this.currentIntegracao = integracao;
      this.historico = [];
      this.$modal.show('integracaoSync');
      this.loadHistorico(integracao.id);
    },

    closeSync() {
      this.stopPolling();
      this.$modal.hide('integracaoSync');
    },

    loadHistorico(integracaoId) {
      this.loadingHistorico = true;
      get(`/admin/tintometrico/integracao/${integracaoId}/sync-historico`)
        .then(json => {
          this.historico = json.data || [];
          this.syncEmAndamento ? this.startPolling() : this.stopPolling();
        })
        .finally(() => { this.loadingHistorico = false; });
    },

    startPolling() {
      this.stopPolling();
      this.pollTimer = setInterval(() => {
        this.loadHistorico(this.currentIntegracao.id);
      }, POLL_INTERVAL_MS);
    },

    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },

    testConnModal() {
      this.testando = true;
      post(`/admin/tintometrico/integracao/${this.currentIntegracao.id}/test-connection`, {})
        .then(() => {
          this.$swal({ title: 'Conexão OK', icon: 'success', confirmButtonText: 'Fechar' });
        })
        .catch(e => {
          this.$swal({ title: 'Falha na Conexão', text: e.message, icon: 'error', confirmButtonText: 'Fechar' });
        })
        .finally(() => { this.testando = false; });
    },

    runSync() {
      this.sincronizando = true;
      post(`/admin/tintometrico/integracao/${this.currentIntegracao.id}/sync`, {})
        .then(() => {
          this.sincronizando = false;
          setTimeout(() => this.loadHistorico(this.currentIntegracao.id), SYNC_START_DELAY_MS);
        })
        .catch(e => {
          this.sincronizando = false;
          this.$swal({ title: 'Erro', text: e.message, icon: 'error' });
        });
    },

    // ── PROGRESSO DAS ETAPAS ─────────────────────────

    stepData(stepName) {
      return this.execucaoAtiva?.etapas?.[stepName] || null;
    },

    stepStatus(stepName) {
      const exec = this.execucaoAtiva;
      if (!exec) return 'pending';

      const data = this.stepData(stepName);

      if (data) {
        return data.erros > 0 ? 'error' : 'done';
      }

      // A próxima etapa a executar é a primeira que não tem dados
      const isNextStep = SYNC_STEP_NAMES.find(s => !exec.etapas?.[s]) === stepName;
      return isNextStep ? 'running' : 'pending';
    },

    stepDetail(stepName) {
      const data = this.stepData(stepName);
      if (!data) return '';

      const parts = [];
      if (data.inseridos) parts.push(`${formatNumber(data.inseridos)} inseridos`);
      if (data.atualizados) parts.push(`${formatNumber(data.atualizados)} atualizados`);
      return parts.join(', ');
    },

    stepProgress(stepName) {
      const data = this.stepData(stepName);
      if (!data?.total || !data?.processados) return null;

      const pct = Math.min(100, Math.round((data.processados / data.total) * 100));
      return { processados: data.processados, total: data.total, pct };
    },

    // ── HELPERS VISUAIS ──────────────────────────────

    filiaisNomes(integracao) {
      return (integracao.filiais || [])
        .map(id => this.filialLabel(id))
        .filter(Boolean)
        .join(', ');
    },

    // Nome da filial pelo id (fallback para o próprio id se o nome não vier no map).
    filialLabel(id) {
      return this.filiais[id] || `Filial ${id}`;
    },

    syncBtnClass(integracao) {
      const lastSync = integracao.ultimaSincronizacao;
      if (lastSync?.id && !lastSync.sucesso) return 'button-error';
      if (lastSync?.sucesso) return 'button-success';
      return 'button-secondary';
    },

    syncStatusClass(status) {
      return STATUS_MAP[status] || 'tinto-badge--muted';
    },

    formatMs(ms) {
      return ms < 1000 ? `${ms}ms` : `${(ms / 1000).toFixed(1)}s`;
    },
  },
};
</script>
